import { Translate } from 'next-translate';
import { SelectOption } from 'types/common';
import { Product } from 'types/Products';

export const getProductSpecsList: (data: Product, t: Translate, locale: string) => SelectOption[] = (
  data,
  t,
  locale
) => {
  const specs = [
    {
      label: t('category'),
      value: data?.category?.name,
    },
    {
      label: t('brand'),
      value: data?.brand?.name,
    },
    {
      label: t('new'),
      value: data.is_new,
    },
    {
      label: t('best-seller'),
      value: data.best_seller,
    },
    {
      label: t('manufacturer-country'),
      value: data.manufacturer_country?.name?.[locale as 'ar' | 'en'],
    },
    {
      label: t('made-year'),
      value: data.made_year,
    },
    {
      label: t('premium'),
      value: data.is_premium,
    },
    {
      label: t('width'),
      value: data.width?.width,
    },
    {
      label: t('height'),
      value: data.height?.height,
    },
    {
      label: t('diameter'),
      value: data.diameter?.diameter,
    },
    {
      label: t('engraving'),
      value: data.engraving?.engraving,
    },
    {
      label: t('run-flat'),
      value: data.run_flat,
    },
    {
      label: t('load-index'),
      value: data.load_index,
    },
    {
      label: t('pitch-circle-diameter'),
      value: data.pitch_circle_diameter?.name,
    },
    {
      label: t('size'),
      value: data.size?.diameter,
    },
    {
      label: t('is-sport'),
      value: data.is_sport,
    },
    {
      label: t('wheel-width'),
      value: data.wheel_width,
    },
    {
      label: t('offset-et'),
      value: data.offset_ET,
    },
    // {
    //   label: t('common-name'),
    //   value: data.common_name,
    // },
    {
      label: t('color'),
      value: data.color,
    },
    {
      label: t('product-line'),
      value: data.product_line,
    },
    {
      label: t('km'),
      value: data.km,
    },
    {
      label: t('volume'),
      value: data.volume,
    },
    {
      label: t('oil-type'),
      value: data.oil_type,
    },
    {
      label: t('power'),
      value: data.power,
    },
    {
      label: t('voltage'),
      value: data.voltage,
    },
    {
      label: t('direction-of-positive'),
      value: data.direction_of_positive,
    },
    {
      label: t('is-set'),
      value: data.is_set,
    },
    {
      label: t('first-direction'),
      value: data.first_direction,
    },
    {
      label: t('second-direction'),
      value: data.second_direction,
    },
    {
      label: t('number-of-flames'),
      value: data.number_of_flames,
    },
    {
      label: t('weight'),
      value: data.weight,
    },
    {
      label: t('battery-exchange'),
      value: data.has_battery_exchange,
    },
    {
      label: t('car-str'),
      value: data.car_str,
    },
    {
      label: t('speed-rating'),
      value: data.speed_rating,
    },
    {
      label: t('is-iron-made'),
      value: data.is_iron_made,
    },
    {
      label: t('version'),
      value: data.version,
    },
  ];

  return specs.filter(
    (spec) => spec.value !== undefined && spec.value !== null && spec.value !== false && spec.value !== ''
  );
};
